import { useEffect, useRef } from "react";
import {
  useSearchParams,
  useNavigation,
} from "@/shared/navigation/useNavigation";
import { env } from "@/env";

export function PreviewAccessHandler() {
  const searchParams = useSearchParams();
  const { replace } = useNavigation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) {
      return;
    }

    const clientSecret = searchParams?.get("client_secret");
    const serverSecret = searchParams?.get("server_secret");

    if (
      clientSecret &&
      serverSecret &&
      clientSecret === env.VITE_SUPER_USER_SECRET
    ) {
      hasProcessed.current = true;

      localStorage.setItem("preview_access_client_secret", clientSecret);
      localStorage.setItem("preview_access_server_secret", serverSecret);

      const newSearchParams = new URLSearchParams(searchParams.toString());
      newSearchParams.delete("client_secret");
      newSearchParams.delete("server_secret");

      const newSearch = newSearchParams.toString();
      const currentPath = window.location.pathname;
      const newUrl = newSearch ? `${currentPath}?${newSearch}` : currentPath;

      replace(newUrl);
    } else {
      const existingClientSecret = localStorage.getItem(
        "preview_access_client_secret",
      );
      const existingServerSecret = localStorage.getItem(
        "preview_access_server_secret",
      );

      if (!existingClientSecret || !existingServerSecret) {
        if (env.VITE_SUPER_USER_SECRET) {
          localStorage.setItem(
            "preview_access_client_secret",
            env.VITE_SUPER_USER_SECRET,
          );
          localStorage.setItem(
            "preview_access_server_secret",
            env.VITE_SUPER_USER_SECRET,
          );
        }
      }
    }
  }, [searchParams, replace]);

  return null;
}
